import axios from "axios";
import { baseUrl } from "../constant";

const serviceFunctions = {
  handleLogout: () => {
    localStorage.removeItem("token");
    window.location.reload();
  },
  handleResendOtp: async ({ mobile }) => {
    try {
      const response = await axios.post(`${baseUrl}/auth/send-otp`, {
        mobile_number: mobile,
      });

      return response.data;
    } catch (err) {
      return err.message;
    }
  },
  handleDirectLogin: async ({ mobile }) => {
    try {
      const response = await axios.post(`${baseUrl}/user/login?direct=true`, {
        mobile_number: mobile,
      });

      return response.data;
    } catch (err) {
      return err.message;
    }
  },
  checkIfUserExist: async ({ mobile }) => {
    try {
      const response = await axios.get(`${baseUrl}/user/isUser/${mobile}`);

      return response.data;
    } catch (err) {
      return null;
    }
  },
   extractNetworkFromToken : (token) => {
     // Example: Assuming the token is a JWT, and the network is stored in the 'network' field
     const decodedToken = serviceFunctions.decodeJWT(token);
     return decodedToken?.network 
   },
  
   // Example decodeJWT function (if token is a JWT)
   decodeJWT :(token) => {
     try {
       const base64Url = token.split('.')[1];
       const base64 = base64Url.replace('-', '+').replace('_', '/');
       const decoded = JSON.parse(window.atob(base64));
       return decoded;
     } catch (error) {
       console.error('Error decoding token:', error);
       return null;
     }
   },
  
};

export default serviceFunctions;
